export default __webpack_public_path__ + "static/media/fa-regular-400.95352b57.woff";